import React, { useState } from 'react'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import MaterialTableCustom from '../../../components/MaterialTableCustom'
import { ExportCsv } from '@material-table/exporters'
import clsx from 'clsx'
import { usePOPlanningTable } from '../../../hooks/queries/POPlanningTable'
import { useHomePageContext } from '../../../context/HomePageProvider'

const useStyles = makeStyles(() => ({
  tablePaper: {
    fontFamily: 'Nunito',
    marginTop: 20,
    borderRadius: 20,
    paddingLeft: 0,
    paddingRight: 20,
    paddingBottom: 20,
    overflow: 'hidden',
    '& .MuiPaper-elevation2': {
      overflow: 'hidden',
      boxShadow: 'unset',
    },
    '& .MuiToolbar-gutters': {
      minHeight: 50,
      marginLeft: 10,
      marginTop: 10,
    },
  },
}))

const PoPlanningTable = ({ project, parentPart }) => {
  const classes = useStyles()
  const [ctbData, setCtbData] = useState({ data: [], columns: [] })
  const { weeksOut } = useHomePageContext()

  usePOPlanningTable(project, parentPart, weeksOut.val, setCtbData)
  const { data } = ctbData

  const columns = [
    { title: 'Part Number', field: 'pn', removable: false },
    {
      title: 'Description',
      field: 'desc',
      cellStyle: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 135,
      },
    },
    { title: 'Qty Required', field: 'requiredQty', type: 'numeric', maxWidth: 120 },
    { title: 'Qty On Hand', field: 'totalQty', type: 'numeric', maxWidth: 80 },
    { title: 'Qty On Order', field: 'onOrderQty', type: 'numeric' },
    { title: 'Shortage Qty', field: 'shortageQty', type: 'numeric', removable: false, maxWidth: 100 },
    {
      title: 'Shortage Date',
      field: 'shortageDate',
      type: 'date',
      maxWidth: 120,
      customSort: (a, b) => {
        const dateA = a.shortageDate ? new Date(a.shortageDate) : 0
        const dateB = b.shortageDate ? new Date(b.shortageDate) : 0
        return dateA - dateB
      },
    },
    { title: 'Lead Time (Weeks)', field: 'leadTimeWeeks', type: 'numeric' },
    {
      title: 'PO Due Date',
      field: 'poDueDate',
      type: 'date',
      removable: false,
      customSort: (a, b) => {
        const dateA = a.poDueDate ? new Date(a.poDueDate) : 0
        const dateB = b.poDueDate ? new Date(b.poDueDate) : 0
        return dateA - dateB
      },
      render: (rowData) => {
        const due = new Date(rowData.poDueDate)
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const overdue = due < today
        return <span style={{ color: overdue ? 'red' : undefined }}>{rowData.poDueDate}</span>
      },
    },
    { title: 'MOQ', field: 'moq', type: 'numeric', hidden: true },
    { title: 'Unit Cost', field: 'unitCost', type: 'numeric', hidden: true },
    { title: 'Total Cost', field: 'totalCost', type: 'numeric', hidden: true },
  ]

  return (
    <Paper className={clsx('mat-table-cont', classes.tablePaper)}>
      <MaterialTableCustom
        title='PO Planning'
        columns={columns}
        data={data}
        headerStyle={{
          marginTop: -5,
          paddingTop: 0,
          paddingBottom: 5,
        }}
        rowStyle={{
          fontSize: `12px`,
          textAlign: 'center',
        }}
        options={{
          search: true,
          paging: false,
          maxBodyHeight: '700px',
          padding: '0',
          resizeable: true,
        }}
      />
    </Paper>
  )
}

export default PoPlanningTable
